import { ReportOverrideFooter } from "../EggFreezeCalculator/types";
import { getFileExtension } from "../../utils";

export interface CustomizeReportConfig {
  logo: string;
  contact_details?: ReportOverrideFooter;
}
export interface CustomizeReportRequestData {
  config: string;
}

export interface CustomizeReportResponse {
  updated: string;
}

export const getOocyteImagePath = (
  userId: string,
  cycle: string,
  id: number,
  fileName: string
): string => {
  return `private/${userId}/oocyte/${cycle}/${id}.${getFileExtension(fileName)}`;
};
